import AxiosService from './AxiosService'

class TokenDatabaseRestService {
  static getTokenDatabase(): Promise<any> {
    return AxiosService.get('/settings/tokendatabase')
  }

  static updateTokenDatabase(databaseConfigInfo: any): Promise<any> {
    return AxiosService.put('/settings/tokendatabase', databaseConfigInfo)
  }

  static isActivated(): Promise<any> {
    return AxiosService.get('/settings/tokendatabase/isActivated')
  }
}

export default TokenDatabaseRestService
